import React from "react";

import * as S from "./styles";
import { Scaffold, Footer } from "components/Shared";
import {
  FormFloat,
  FormMobile,
  Banner,
  Numbers,
  Recognition,
  Video,
  SocialProof,
  Differences,
  ReasonsInvest,
  Investment,
  Ambassadors,
  Midia,
  Features,
  FeaturesNew,
  FAQ,
} from "components/Franchising2024";

export const Franchising2024: React.FC = () => {
  return (
    <Scaffold>
      <FormFloat />
      <Banner />
      <FormMobile />
      <Numbers />
      <Recognition />
      <Video />
      <SocialProof />
      <Differences />
      <ReasonsInvest />
      <Investment />
      <Ambassadors />
      <Midia />
      {/* <Features /> */}
      <FeaturesNew />
      <FAQ />
      <FormMobile />
      <Footer />
    </Scaffold>
  );
};
